module.exports = __webpack_public_path__ + "static/media/eco-ecology-gear-svgrepo-com.a3bb2638.svg";